module.exports = __webpack_public_path__ + "img/logo-cvc-120x120.1dc1f05b.png";